import createIcon from '../../createIcon';

/**
 * @component @name FormatAlignRight
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMyAyMUgyMVYxOUgzVjIxWk05IDE3SDIxVjE1SDlWMTdaTTMgMTNIMjFWMTFIM1YxM1pNOSA5SDIxVjdIOVY5Wk0zIDNWNUgyMVYzSDNaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const FormatAlignRight = createIcon('FormatAlignRight', [
  [
    'path',
    {
      d: 'M3 21H21V19H3V21ZM9 17H21V15H9V17ZM3 13H21V11H3V13ZM9 9H21V7H9V9ZM3 3V5H21V3H3Z',
      key: 'moerha',
    },
  ],
]);

export default FormatAlignRight;
